import dayjs from 'dayjs';
import { DataModel } from '../models/dto/dto.js';
import { BusinessModuleRef } from '../models/serializable/business-module-ref.js';

export abstract class DiscountCodeBase extends DataModel {
  abstract get uniqueId(): string;
  abstract get businessRef(): BusinessModuleRef;
  abstract get code(): string;
  abstract get creationDate(): dayjs.Dayjs;
}
